import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Heading, Image, LinkButton, RichText } from "../../element";
import { ColumnContainer, Container, TextContainer } from "./StandardContentRowBlock.styles";
var getCols = function(chunks) {
    if (chunks === 2) {
        return 6;
    }
    return chunks === 3 ? 4 : 3;
};
var getContainerCols = function(chunks) {
    return [
        [
            12
        ],
        [
            getCols(chunks),
            "md",
            {
                condition: chunks > 1 && chunks < 5
            }
        ], 
    ];
};
var getContentCols = function(chunks) {
    return [
        [
            12
        ],
        [
            8,
            "lg",
            {
                condition: chunks === 1
            }
        ], 
    ];
};
export var StandardContentRowBlock = function(param) {
    var chunks = param.content.chunks;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: chunks.map(function(param) {
            var body = param.body, image = param.image, heading = param.heading, link = param.link;
            var containerColumns = getContainerCols(chunks.length);
            var columns = getContentCols(chunks.length);
            return /*#__PURE__*/ _jsx(Container, {
                rules: {
                    columns: containerColumns
                },
                children: /*#__PURE__*/ _jsxs(ColumnContainer, {
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            content: image,
                            rules: {
                                hasMinSize: chunks.length < 3
                            }
                        }),
                        /*#__PURE__*/ _jsxs(TextContainer, {
                            children: [
                                /*#__PURE__*/ _jsx(Heading, {
                                    content: _object_spread_props(_object_spread({}, heading), {
                                        level: heading.level || "h3"
                                    }),
                                    rules: {
                                        columns: columns
                                    }
                                }),
                                /*#__PURE__*/ _jsx(RichText, {
                                    content: body,
                                    rules: {
                                        columns: columns
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(LinkButton, {
                            content: link,
                            rules: {
                                variant: "secondary",
                                size: "small"
                            }
                        })
                    ]
                })
            }, heading.text);
        })
    });
};
